import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=3ee27b7e&"
import script from "./UserInfo.vue?vue&type=script&lang=js&"
export * from "./UserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee27b7e')) {
      api.createRecord('3ee27b7e', component.options)
    } else {
      api.reload('3ee27b7e', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=3ee27b7e&", function () {
      api.rerender('3ee27b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/UserInfo.vue"
export default component.exports